import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { GapEnum } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import { TicketPriority } from '@delmonicos/shared-sdk/libs/cpms/src/libs/support-service-lib/src/wrapper/enums/ticket-priority.enum';

import { PRIORITY_CONFIG } from './priority-tag.helper';

interface PriorityTagComponentProps {
  priority: TicketPriority;
}

export const PriorityTagComponent = ({
  priority,
}: PriorityTagComponentProps): React.JSX.Element => {
  const config = PRIORITY_CONFIG[priority];

  return (
    <Tag className={config.tagClass} gap={GapEnum.XXS}>
      <Icon name={config.icon} color={config.iconColor} />
    </Tag>
  );
};
